import { render, staticRenderFns } from "./CurrentLeaseItem.vue?vue&type=template&id=516134a0&"
import script from "./CurrentLeaseItem.vue?vue&type=script&lang=js&"
export * from "./CurrentLeaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516134a0')) {
      api.createRecord('516134a0', component.options)
    } else {
      api.reload('516134a0', component.options)
    }
    module.hot.accept("./CurrentLeaseItem.vue?vue&type=template&id=516134a0&", function () {
      api.rerender('516134a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/components/CurrentLeaseItem.vue"
export default component.exports